export enum Permission {
  CREATE_USER = 'create:user',
  CREATE_STREAM = 'create:stream',
  CREATE_SUMMARY_CRITERION = 'create:summaryCriterion',
  UPDATE_DECISION = 'update:decision',
  UPDATE_DECISION_RENEWAL = 'update:decisionRenewal',
  UPDATE_OWNER = 'update:owner',
}

export enum Role {
  CONTRIBUTOR = 'CONTRIBUTOR',
  DECISION_MAKER = 'DECISION_MAKER',
  ADMINISTRATOR = 'ADMINISTRATOR',
}
